import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { BiLogger, createBiLogger } from '../bi/biLoggerFactory';
import { Api } from '../../api';
import { PanoramaLogger } from '../fedops';

export type ActionsContext = {
  flowAPI: ControllerFlowAPI;
  api: Api;
  biLogger?: BiLogger;
  panoramaLogger?: PanoramaLogger;
};

export const createActionsContext = ({
  flowAPI,
}: {
  flowAPI: ControllerFlowAPI;
}): ActionsContext => {
  const api = new Api({ flowAPI });

  return {
    flowAPI,
    api,
    biLogger: createBiLogger({ flowAPI, api }),
    panoramaLogger: new PanoramaLogger(flowAPI),
  };
};
